module.exports = __webpack_public_path__ + "static/1327919661-wide.1d06dfbb.jpg";